import { render, staticRenderFns } from "./jftable.vue?vue&type=template&id=1e16a98e&"
import script from "./jftable.vue?vue&type=script&lang=js&"
export * from "./jftable.vue?vue&type=script&lang=js&"
import style0 from "./jftable.vue?vue&type=style&index=0&id=1e16a98e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports